module.exports = __webpack_public_path__ + "img/logo.06b15780.png";